import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Search } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useDebouncedValue } from '@/shared/hooks/useDebouncedValue';

type Props = { value: string; onChange: (q: string) => void };

/** Typing stays local and debounced; the URL (via onChange) is the source of truth. */
export function DraftSearch({ value, onChange }: Props) {
  const [text, setText] = useState(value);
  const [synced, setSynced] = useState(value);
  const settled = useDebouncedValue(text.trim());
  const onChangeRef = useRef(onChange);

  // Cleared or changed from outside (tab switch, back button): adopt it.
  if (value !== synced) {
    setSynced(value);
    setText(value);
  }

  useEffect(() => { onChangeRef.current = onChange; });
  useEffect(() => {
    if (settled !== synced) onChangeRef.current(settled);
  }, [settled, synced]);

  return (
    <TextField
      size="small"
      fullWidth
      type="search"
      placeholder="Search drafts, people or lists"
      value={text}
      onChange={(e) => { setText(e.target.value); }}
      slotProps={{
        htmlInput: { 'aria-label': 'Search drafts, people or lists' },
        input: { startAdornment: <InputAdornment position="start"><Search size={15} aria-hidden /></InputAdornment> },
      }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.25, fontSize: '0.8125rem', bgcolor: 'background.paper' } }}
    />
  );
}
